<template>
	<svg
		width="19px"
		height="19px"
		viewBox="0 0 19 19"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
	>
		<title>Checkmark</title>
		<g
			id="Org-Management"
			stroke="none"
			stroke-width="1"
			fill="none"
			fill-rule="evenodd"
		>
			<g id="Preview-Import" transform="translate(-480.000000, -259.000000)">
				<g id="Group-36" transform="translate(421.000000, 113.000000)">
					<g id="Group-36-Copy" transform="translate(59.000000, 143.000000)">
						<g id="Group-44-Copy-8" transform="translate(0.000000, 3.000000)">
							<g
								id="Group-46-Copy-7"
								transform="translate(-0.000000, -0.000000)"
								:stroke="color"
								stroke-width="2"
							>
								<circle id="Oval" cx="9.5" cy="9.5" r="8.5"></circle>
							</g>
							<g
								id="check-solid"
								transform="translate(4.652017, 5.961906)"
								:fill="color"
								fill-rule="nonzero"
							>
								<path
									d="M3.45573429,6.93721272 L0.148996935,3.85323072 C-0.049665645,3.66795086 -0.049665645,3.36754062 0.148996935,3.18224223 L0.868430904,2.51125374 C1.06709348,2.32595535 1.38922216,2.32595535 1.58788474,2.51125374 L3.81546121,4.58875301 L8.58668179,0.138959892 C8.78534437,-0.0463199641 9.10747305,-0.0463199641 9.30613563,0.138959892 L10.0255696,0.809948381 C10.2242322,0.995228237 10.2242322,1.29563848 10.0255696,1.48093687 L4.17518813,6.93723126 C3.97650568,7.12251111 3.65439687,7.12251111 3.45573429,6.93721272 L3.45573429,6.93721272 Z"
									id="Path"
								></path>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'OutlineCheckmark',
	props: {
		color: {
			type: String,
			default: '#00DAB6',
		},
	},
}
</script>
